<div [ngClass]="Theme">
    <div class="wrapper-chip">
        <app-icon *ngIf="Ico !== undefined" class="icon" Path="assets/img/iconos/{{Ico}}"></app-icon>
        <app-text Theme="BodyRegular" Text="{{Label}}" [RadiusLoading]="10"></app-text>
    </div>
</div>